module.exports = __webpack_public_path__ + "img/1958.925c0c31.svg";